export const LOADING_GET_CATALOG = 'STUDY_PLANS::LOADING_GET_CATALOG';
export const RECEIVE_GET_CATALOG = 'STUDY_PLANS::RECEIVE_GET_CATALOG';
export const ERROR_GET_CATALOG = 'STUDY_PLANS::ERROR_GET_CATALOG';

export const LOADING_GET_STUDY_PLAN_LEVELS = 'STUDY_PLANS::LOADING_GET_STUDY_PLAN_LEVELS';
export const RECEIVE_GET_STUDY_PLAN_LEVELS = 'STUDY_PLANS::RECEIVE_GET_STUDY_PLAN_LEVELS';
export const ERROR_GET_STUDY_PLAN_LEVELS = 'STUDY_PLANS::ERROR_GET_STUDY_PLAN_LEVELS';
